import { BoosterOptimizer } from '/home/runner/work/booster-landing-optimizer/booster-landing-optimizer/dist/temp/compiled/src/index.js';
import { DEFAULT_TEST_NAME } from '/home/runner/work/booster-landing-optimizer/booster-landing-optimizer/dist/temp/compiled/src/core/ab-testing.js';


/**
 * Booster Landing Optimizer - image-proxy variant
 * image proxy only
 * Auto-generated entry point with A/B testing support
 */

// Create optimizer with A/B testing and specific plugins for this variant
const optimizer = new BoosterOptimizer({
  debug: false,
  plugins: ['ImageProxyPlugin'],
  abTesting: {
    enabled: true,
    testName: DEFAULT_TEST_NAME
    // applyRate will be parsed from URL params or use default
  },
  analytics: {
    enabled: true,
    trackTestGroups: true,
    trackPerformance: true
  }
}, document.currentScript.src);

// Make globally available for debugging
window.__BOOSTER_OPTIMIZER__ = optimizer;

// Auto-initialize based on timing
async function init() {
  try {
    await optimizer.run();
    console.log('[Booster-image-proxy] Variant initialized with A/B testing');
    console.log('[Booster-image-proxy] Test group:', optimizer.getTestGroup());
    console.log('[Booster-image-proxy] Is treatment:', optimizer.isTreatmentGroup());
  } catch (error) {
    console.error('[Booster-image-proxy] Error during initialization:', error);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

// Export for manual control and compatibility
export { optimizer };
export default optimizer;
